"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackViewEventCounts = trackViewEventCounts;
const trackEventCounts_1 = require("../trackEventCounts");
function trackViewEventCounts(lifeCycle, viewId, onChange) {
    const { stop, eventCounts } = (0, trackEventCounts_1.trackEventCounts)({
        lifeCycle,
        isChildEvent: (event) => event.view.id === viewId,
        onChange,
    });
    return {
        stop,
        eventCounts,
    };
}
//# sourceMappingURL=trackViewEventCounts.js.map